<template>
<div>
  <div id="activity-nav" class="fixed-right" infinite-wrapper>
    <b-list-group>
      <b-list-group-item
          v-for="activity in items"
          :key="activity.id"
          class="border-left-0 border-right-0 border-top border-bottom-0 pt-4 pb-4"
      >

        <ProcessActivity :activity="activity" v-if="activity.subject_type === 'App\\Process\\Models\\Process'"/>
        <ProcessGdprActivity :activity="activity" v-if="activity.subject_type === 'App\\Process\\Models\\ProcessGdpr'"/>
        <ProcessPolicyActivity :activity="activity" v-if="activity.subject_type === 'App\\Process\\Models\\ProcessPolicy'"/>
        <ProcessLegalBasisActivity :activity="activity" v-if="activity.subject_type === 'App\\Process\\Models\\ProcessLegalBasis'"/>
        <ProcessInformationObligationActivity Activity :activity="activity" v-if="activity.subject_type === 'App\\Process\\Models\\ProcessInformationObligation'"/>

        <SystemActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\System'"/>
        <SystemPolicyActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemPolicy'"/>
        <SystemNetworkActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemNetwork'"/>
        <SystemLogManagementActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemLogManagement'"/>
        <SystemDataObjectActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemDataObject'"/>
        <SystemDataDiscoveryActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemDataDiscovery'"/>
        <SystemAccessControlActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemAccessControl'"/>
        <SystemThirdPartyActivity :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemThirdParty'"/>

        <ActivityActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\Activity'"/>
        <ActivityGdprActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityGdpr'"/>
        <ActivityPolicyActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityPolicy'"/>
        <ActivityDataSubjectActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityDataSubject'"/>
        <ActivityIntegrityControlActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityIntegrityControl'"/>
        <ActivityOrganizationActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityOrganization'"/>
        <ActivityRetentionRuleActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityRetentionRule'"/>
        <ActivitySystemActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivitySystem'"/>
        <ActivityThirdPartyActivity :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityThirdParty'"/>

        <ValidationActivity :activity="activity" v-if="activity.subject_type === 'App\\Validation\\Models\\Validation'"/>

        <ActivityProjectActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Project\\Models\\Project'"/>
        <!--<ActivityProjectActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Project\\Models\\Project'"/>-->

        <FrameworkActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Framework\\Models\\Framework'"/>
        <FrameworkControlObjectiveActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ControlObjective\\Models\\ControlObjective'"/>
        <FrameworkControlActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\FrameworkControl\\Models\\FrameworkControl'"/>


        <RiskScenarioActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\RiskScenario\\Models\\RiskScenario'"/>
        <RiskScenarioThreatActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\RiskScenario\\Models\\RiskScenarioThreat'"/>
        <RiskScenarioVulnerabilityActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\RiskScenario\\Models\\RiskScenarioVulnerability'"/>

        <ThirdPartyActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
        <ThirdPartyDataObjectActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartyDataObject'"/>


        <ThirdPartyRiskScenarioActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartyRiskScenario'"/>
        <SystemRiskScenarioActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemRiskScenario'"/>
        <ActivityRiskScenarioActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityRiskScenario'"/>
        <ProcessRiskScenarioActivity :activity="activity" :changes="true" v-if="activity.subject_type === 'App\\Process\\Models\\ProcessRiskScenario'"/>

        <GenericControlActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControl'"/>
        <GenericControlFrameworkActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlFramework'"/>
        <GenericControlRiskScenarioActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlRiskScenario'"/>
        <GenericControlPolicyActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlPolicy'"/>
        <GenericControlThreatActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlThreat'"/>
        <GenericControlVulnerabilityActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlVulnerability'"/>


        <AssessmentActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Assessment\\Models\\Assessment'"/>
        <QuestionActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Assessment\\Models\\Question'"/>

        <ProjectModelActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Project\\Models\\ProjectModel'"/>
        <ProjectTaskActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Project\\Models\\ProjectTask'"/>

        <MeasureActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Measure\\Models\\Measure'"/>
        <ActivityMeasureActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Activity\\Models\\ActivityMeasure'"/>
        <SystemMeasureActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\System\\Models\\SystemMeasure'"/>
        <ThirdPartyMeasureActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartyMeasure'"/>
        <GenericControlMeasureActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\GenericControl\\Models\\GenericControlMeasure'"/>

        <VendorActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\Vendor'"/>
        <ThirdPartyDocumentActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartyDocument'"/>

        <PolicyActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Policy\\Models\\Policy'"/>

        <PolicyDocumentActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\Policy\\Models\\PolicyDocument'"/>

        <ThirdPartyContactActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartyContact'"/>
        <ThirdPartySubdataProcessorActivity :changes="true" :activity="activity" v-if="activity.subject_type === 'App\\Maintenance\\ThirdParty\\Models\\ThirdPartySubdataProcessor'"/>

      </b-list-group-item>
    </b-list-group>
    <hr class="mt-0"/>
    <div class="text-center text-muted" v-if="loading">
      {{ $t('system.loading')}}
    </div>
    <div class="text-center text-muted" v-if="!loading && items && !items.length">
      {{ $t('system.no_data')}}.
    </div>
    <InfiniteLoading @infinite="loadingHandler" :identifier="scrollIdentifier" force-use-infinite-wrapper>
      <template slot="no-results">
        <span></span>
      </template>
    </InfiniteLoading>
  </div>
</div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import ProcessActivity from '@/components/activity/process/Process.vue';
import ProcessGdprActivity from '@/components/activity/process/ProcessGdpr.vue';
import ProcessPolicyActivity from '@/components/activity/process/ProcessPolicy.vue';
import ProcessLegalBasisActivity from '@/components/activity/process/ProcessLegalBasis.vue';
import ProcessInformationObligationActivity from '@/components/activity/process/ProcessInformationObligation.vue';

import SystemActivity from '@/components/activity/system/System.vue';
import SystemPolicyActivity from '@/components/activity/system/SystemPolicy.vue';
import SystemNetworkActivity from '@/components/activity/system/SystemNetwork.vue';
import SystemLogManagementActivity from '@/components/activity/system/SystemLogManagement.vue';
import SystemDataObjectActivity from '@/components/activity/system/SystemDataObject.vue';
import SystemDataDiscoveryActivity from '@/components/activity/system/SystemDataDiscovery.vue';
import SystemAccessControlActivity from '@/components/activity/system/SystemAccessControl.vue';
import SystemThirdPartyActivity from '@/components/activity/system/SystemThirdParty.vue';

import ActivityActivity from '@/components/activity/activity/Activity.vue';
import ActivityGdprActivity from '@/components/activity/activity/ActivityGdpr.vue';
import ActivityPolicyActivity from '@/components/activity/activity/ActivityPolicy.vue';
import ActivityDataSubjectActivity from '@/components/activity/activity/ActivityDataSubject.vue';
import ActivityIntegrityControlActivity from '@/components/activity/activity/ActivityIntegrityControl.vue';
import ActivityOrganizationActivity from '@/components/activity/activity/ActivityOrganization.vue';
import ActivityRetentionRuleActivity from '@/components/activity/activity/ActivityRetentionRule.vue';
import ActivitySystemActivity from '@/components/activity/activity/ActivitySystem.vue';
import ActivityThirdPartyActivity from '@/components/activity/activity/ActivityThirdParty.vue';

import ValidationActivity from '@/components/activity/validation/Validation.vue';

import ActivityProjectActivity from '@/components/activity/activity/ActivityProject.vue';

import FrameworkActivity from '@/components/activity/framework/Framework.vue';
import FrameworkControlObjectiveActivity from '@/components/activity/framework/FrameworkControlObjective.vue';
import FrameworkControlActivity from '@/components/activity/framework/FrameworkControl.vue';

import RiskScenarioActivity from '@/components/activity/risk/RiskScenario.vue';
import RiskScenarioThreatActivity from '@/components/activity/risk/RiskScenarioThreat.vue';
import RiskScenarioVulnerabilityActivity from '@/components/activity/risk/RiskScenarioVulnerability.vue';
import RiskScenarioValidationActivity from '@/components/activity/risk/RiskScenarioValidation.vue';

import ThirdPartyActivity from '@/components/activity/thirdparty/ThirdParty.vue';
import ThirdPartyDataObjectActivity from '@/components/activity/thirdparty/ThirdPartyDataObject.vue';

import ThirdPartyRiskScenarioActivity from '@/components/activity/thirdparty/ThirdPartyRiskScenario.vue';
import SystemRiskScenarioActivity from '@/components/activity/system/SystemRiskScenario.vue';
import ActivityRiskScenarioActivity from '@/components/activity/activity/ActivityRiskScenario.vue';
import ProcessRiskScenarioActivity from '@/components/activity/process/ProcessRiskScenario.vue';

import GenericControlActivity from '@/components/activity/genericcontrol/GenericControl.vue';
import GenericControlFrameworkActivity from '@/components/activity/genericcontrol/GenericControlFramework.vue';
import GenericControlRiskScenarioActivity from '@/components/activity/genericcontrol/GenericControlRiskScenario.vue';
import GenericControlPolicyActivity from '@/components/activity/genericcontrol/GenericControlPolicy.vue';
import GenericControlThreatActivity from '@/components/activity/genericcontrol/GenericControlThreat.vue';
import GenericControlVulnerabilityActivity from '@/components/activity/genericcontrol/GenericControlVulnerability.vue';

import AssessmentActivity from '@/components/activity/assessment/Assessment.vue';
import QuestionActivity from '@/components/activity/assessment/Question.vue';

import InfiniteLoading from 'vue-infinite-loading';

import ProjectModelActivity from '@/components/activity/project/ProjectModel.vue';
import ProjectTaskActivity from '@/components/activity/project/ProjectTask.vue';
import MeasureActivity from '@/components/activity/measure/Measure.vue';
import ActivityMeasureActivity from '@/components/activity/activity/ActivityMeasure.vue';
import SystemMeasureActivity from '@/components/activity/system/SystemMeasure.vue';
import ThirdPartyMeasureActivity from '@/components/activity/thirdparty/ThirdPartyMeasure.vue';
import GenericControlMeasureActivity from '@/components/activity/genericcontrol/GenericControlMeasure.vue';

import VendorActivity from '@/components/activity/thirdparty/Vendor.vue';
import ThirdPartyDocumentActivity from '@/components/activity/thirdparty/ThirdPartyDocument.vue';

import PolicyActivity from '@/components/activity/policy/Policy.vue';
import PolicyValidationActivity from '@/components/activity/policy/PolicyValidation.vue';
import PolicyDocumentActivity from '@/components/activity/policy/PolicyDocument.vue';

import ThirdPartyContactActivity from '@/components/activity/thirdparty/ThirdPartyContact.vue';
import ThirdPartySubdataProcessorActivity from '@/components/activity/thirdparty/ThirdPartySubdataProcessor.vue';

export default {
  name: 'ActivityNavigation',
  data: function() {
    return {
      activeNavbar: this.$store.state.activeNavbar,
      items: [],
      currentPage: 1,
      totalRows: 0,
      loading: true,
      page: 1,
      scrollIdentifier: 1
    }
  },
  props: {
    updateActivity: {
      type: Boolean
    }
  },
  watch: {
    updateActivity: function (newValue) {
      if (newValue) {
        this.items = []
        this.page = 1
        this.loadingHandler()
      }
    }
  },
  components: {
    ProcessActivity,
    ProcessGdprActivity,
    ProcessPolicyActivity,
    ProcessLegalBasisActivity,
    SystemActivity,
    SystemPolicyActivity,
    SystemNetworkActivity,
    SystemLogManagementActivity,
    SystemDataObjectActivity,
    SystemDataDiscoveryActivity,
    SystemAccessControlActivity,
    SystemThirdPartyActivity,
    ActivityActivity,
    ActivityPolicyActivity,
    ActivityDataSubjectActivity,
    ActivityIntegrityControlActivity,
    ActivityOrganizationActivity,
    ActivityRetentionRuleActivity,
    ActivitySystemActivity,
    ActivityThirdPartyActivity,
    ActivityGdprActivity,
    ValidationActivity,
    InfiniteLoading,
    ProcessInformationObligationActivity,
    ActivityProjectActivity,
    FrameworkActivity,
    FrameworkControlObjectiveActivity,
    FrameworkControlActivity,
    RiskScenarioActivity,
    RiskScenarioThreatActivity,
    RiskScenarioVulnerabilityActivity,
    RiskScenarioValidationActivity,
    ThirdPartyActivity,
    ThirdPartyDataObjectActivity,
    ThirdPartyRiskScenarioActivity,
    SystemRiskScenarioActivity,
    ActivityRiskScenarioActivity,
    ProcessRiskScenarioActivity,
    GenericControlActivity,
    GenericControlFrameworkActivity,
    GenericControlRiskScenarioActivity,
    GenericControlPolicyActivity,
    GenericControlThreatActivity,
    GenericControlVulnerabilityActivity,
    AssessmentActivity,
    QuestionActivity,
    ProjectModelActivity,
    ProjectTaskActivity,
    MeasureActivity,
    ActivityMeasureActivity,
    SystemMeasureActivity,
    ThirdPartyMeasureActivity,
    GenericControlMeasureActivity,
    VendorActivity,
    ThirdPartyDocumentActivity,
    PolicyActivity,
    PolicyValidationActivity,
    PolicyDocumentActivity,
    ThirdPartyContactActivity,
    ThirdPartySubdataProcessorActivity
  },
  computed: {
    getNavType() {
      return this.$store.state.activeNavbar
    },
    getClient() {
      return this.$store.state.client
    }
  },
  methods: {
    loadingHandler($state) {
      this.loading = true;
      let self = this
      piincHttp.get('activity-log', { params:
        {
          page: this.page,
          client: self.getClient.slug
        }
      }).then(({ data }) => {
        if (data.items.length) {
          self.page += 1;
          self.items.push(...data.items);
          if ($state) {
            $state.loaded();
          }
        } else {
          if ($state) {
            $state.complete();
          }
        }
        self.loading = false;
      });
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
    }
  }
}
</script>
